/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	},
  	locale: boostPFSConfig.general.current_locale
};

(function() {
	BoostPFS.inject(this);
  
      InstantSearch.prototype.beforeInit = function(id) {
      jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]').each(function(i) {
        if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
          var clone = jQ(this).clone();
          jQ(this).replaceWith(clone);
        }
      }); 

    }
  
    InstantSearchResultItemProduct.prototype.compileTemplate = function() {
          if (this.isShow) {
              var searchTerm = Utils.escape(Globals.currentTerm);
              // Product image
              var imageHTML = '';
              if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
                  imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
                  imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
              }
              // Product title
              var productTitle = this.customizeProductTitle();
              productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
              // SKU
              var skuHTML = '';
              if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
                  skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
                  skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
              }
              // Vendor
              var vendorHTML = '';
              if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
                  vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
                  vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
              }
              // Price
              var showprice = true;
              for (const tag of this.data.tags) {
                if (tag == 'hprice' ) {
                	showprice = false;
                	break;  
                }
              }
              if (showprice) {
                  var priceHTML = this.compileSuggestionProductPrice();
              } else {
                   if (boostPFSConfig.general.current_locale == "en") {
                        priceHTML = '<p class="boost-pfs-filter-product-item-price">Price upon request</p>';
                    } else if (boostPFSConfig.general.current_locale == "it") {
                        priceHTML = '<p class="boost-pfs-filter-product-item-price">Prezzo su richiesta</p>';
                    };
              }
              // Open the result item in new tab when selected
              var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
              return this.getTemplate()
                  .replace(/{{id}}/g, this.id)
                  .replace(/{{escapedBlockType}}/g, Utils.escape(this.parent.type))
                  .replace(/{{url}}/g, this.url)
                  .replace(/{{newTabAttribute}}/g, newTabAttr)
                  .replace(/{{itemProductImage}}/g, imageHTML)
                  .replace(/{{title}}/g, productTitle)
                  .replace(/{{escapedTitle}}/g, Utils.escape(productTitle))
                  .replace(/{{itemProductSku}}/g, skuHTML)
                  .replace(/{{itemProductVendor}}/g, vendorHTML)
                  .replace(/{{itemProductPrice}}/, priceHTML)
                  .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
                  .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
                  .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
          } else {
              return '';
          }
      }

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

InstantSearchResultItemProduct.prototype.afterRender = function () {
  if (this.hasOwnProperty("data") && this.data !== null) {
    var data = this.data;
    var priceHtml = this.compileSuggestionProductPrice().replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion);
    var _this = this;
    ajaxPrice(data);
  }
};

function ajaxPrice(productData) {
  var activeCurrency = Shopify.currency.active.toUpperCase();
  try {
    // Use Session Storage
    if (
      typeof sessionStorage !== "undefined" &&
      typeof config[productData.id] !== "undefined" &&
      typeof config[productData.id][activeCurrency] !== "undefined"
    ) {
      console.log("Good");
      var onSale =
        config[productData.id][activeCurrency].compare_at_price_min > config[productData.id][activeCurrency].price_min;
      // Format price
      var price = Utils.formatMoney(config[productData.id][activeCurrency].price_min);
      var compareAtPrice = "";
      if (config[productData.id][activeCurrency].compare_at_price_min) {
        compareAtPrice = Utils.formatMoney(config[productData.id][activeCurrency].compare_at_price_min);
        if (Settings.getSettingValue("search.removePriceDecimal")) {
          price = Utils.removeDecimal(price);
          compareAtPrice = Utils.removeDecimal(compareAtPrice);
        }
      }

      // Build Price
      var result = "";
      if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
        if (onSale && Settings.getSettingValue("search.showSuggestionProductSalePrice")) {
          result =
            '<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;<s>{{compareAtPrice}}</s>';
        } else {
          result = '<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>';
        }
      }
      result = result
        .replace(/{{regularPrice}}/g, price)
        .replace(/{{compareAtPrice}}/g, compareAtPrice)
        .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion);

      setTimeout(function (params) {
        if (
          jQ(
            '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
              productData.id +
              '"] .' +
              Class.searchSuggestion +
              "-product-price",
          )
        ) {
          jQ(
            '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
              productData.id +
              '"] .' +
              Class.searchSuggestion +
              "-product-price",
          ).html(result);
        }
      }, 300);
    } else {
      console.log("Almost Good");
      // Use Ajax
      // Set link for ajax
      let productHandleAjax =
        Shopify.routes.root + "products/" + productData.handle + "?view=boost-pfs-custom-integration";
      let requestReg = formRequest(productHandleAjax);
      requestReg
        .then((res_success) => {
          let parse_res_success = JSON.parse(res_success);
          // Set dataAjax session storage config
          var activeCurrencyData = {};
          activeCurrencyData[activeCurrency] = parse_res_success;
          try {
            setConfig(parse_res_success.id, activeCurrencyData);
          } catch (error) {
            console.error(error);
          }
          // Render Ajax Data
          var onSale = parse_res_success.compare_at_price_min > parse_res_success.price_min;
          // Format price
          var price = Utils.formatMoney(parse_res_success.price_min);
          var compareAtPrice = "";
          if (parse_res_success.compare_at_price_min) {
            compareAtPrice = Utils.formatMoney(parse_res_success.compare_at_price_min);
            if (Settings.getSettingValue("search.removePriceDecimal")) {
              price = Utils.removeDecimal(price);
              compareAtPrice = Utils.removeDecimal(compareAtPrice);
            }
          }

          // Build Price
          var result = "";
          if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
            if (onSale && Settings.getSettingValue("search.showSuggestionProductSalePrice")) {
              result =
                '<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;<s>{{compareAtPrice}}</s>';
            } else {
              result = '<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>';
            }
          }
          result = result
            .replace(/{{regularPrice}}/g, price)
            .replace(/{{compareAtPrice}}/g, compareAtPrice)
            .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion);
          if (
            jQ(
              '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
                productData.id +
                '"] .' +
                Class.searchSuggestion +
                "-product-price",
            )
          ) {
            jQ(
              '.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product[data-id="' +
                productData.id +
                '"] .' +
                Class.searchSuggestion +
                "-product-price",
            ).html(result);
          }
        })
        .catch((res_error) => {
          console.error(res_error);
        });
    }
  } catch (e) {}
}
// Add session storage config
if (typeof sessionStorage !== "undefined") {
  var CUSTOM_HTML_STORAGE_KEY = "sicis_jewels_AjaxData";
  var config = JSON.parse(sessionStorage.getItem(CUSTOM_HTML_STORAGE_KEY)) || {};
  function setConfig(key, value) {
    config[key] = value;
    sessionStorage.setItem(CUSTOM_HTML_STORAGE_KEY, JSON.stringify(config));
  }
}

function formRequest(value) {
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", value);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = () => resolve(xhr.responseText);
    xhr.onerror = () => reject(xhr.statusText);
    xhr.send();
  });
}

})();